export class AuthErrorInstance {

    public static instance: AuthErrorInstance;
    private isRedirectedToLogin: boolean = false;
    private constructor() { }

    public static getInstance(): AuthErrorInstance {
        if (AuthErrorInstance.instance === undefined) {
            AuthErrorInstance.instance = new AuthErrorInstance();
        }
        return AuthErrorInstance.instance;
    }

    public get isRedirected () {
        return this.isRedirectedToLogin;
    }

    public setIsRedirected(value: boolean) {
        return this.isRedirectedToLogin = value;
    }

}